import { render } from "./tab-learn-reading.vue?vue&type=template&id=4cf335a8&scoped=true"
import script from "./tab-learn-reading.vue?vue&type=script&lang=js"
export * from "./tab-learn-reading.vue?vue&type=script&lang=js"

import "./tab-learn-reading.vue?vue&type=style&index=0&id=4cf335a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf335a8"]])

export default __exports__